var _defs, _path, _path2, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCharleyFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a494a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.899,52.11l-3.25-29.95A13.74512,13.74512,0,0,0,67.36894,10h-.08a264.40845,264.40845,0,0,0-56.74,6.15.23492.23492,0,0,0-.08.02A13.74251,13.74251,0,0,0,.099,30.88l3.25,29.95a13.74517,13.74517,0,0,0,13.28,12.16h.08a267.01521,267.01521,0,0,0,28.53-1.54q5.76-.615,11.56995-1.51c1.33-.21,2.67-.42,4-.65l.75,8.46a1.21489,1.21489,0,0,0,2.04.78l15.52-14.47c.02-.02.04-.03.06-.05l.93006-.88c.00995-.01.02-.01.02-.02a1.24846,1.24846,0,0,0,.25-.38,14.41832,14.41832,0,0,0,1.5-1.97A13.54325,13.54325,0,0,0,83.899,52.11Zm-11.81,8.5a257.94386,257.94386,0,0,1-55.39,6,7.42789,7.42789,0,0,1-7.01-6.46Q8.069,45.165,6.449,30.2a7.42267,7.42267,0,0,1,5.46-7.82,257.94392,257.94392,0,0,1,55.39-6,7.42783,7.42783,0,0,1,7.01,6.46q1.62,14.985,3.24,29.95A7.42273,7.42273,0,0,1,72.089,60.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.71515,57.24485a28.30075,28.30075,0,0,1-10.17735-1.9847,1.35011,1.35011,0,0,1,.967-2.52115,23.38365,23.38365,0,0,0,22.5708-2.44533,1.35023,1.35023,0,1,1,1.48474,2.25567A26.66775,26.66775,0,0,1,40.71515,57.24485Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 29.38133,
    cy: 37.11612,
    rx: 5.11213,
    ry: 8.80315,
    transform: "translate(-3.82695 3.38069) rotate(-6.1835)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 52.89401,
    cy: 34.56867,
    rx: 5.11213,
    ry: 8.80315,
    transform: "translate(-3.41576 5.8985) rotate(-6.1835)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCharleyFilled);
export default __webpack_public_path__ + "static/media/ic_charley_filled.849bcdf1653ac77ea9e0182c1ce10422.svg";
export { ForwardRef as ReactComponent };